/* eslint-disable max-len */
import { Icon, IconGraphic } from '@design-system/components/atoms/icon/entities/icon.types';

export const IconChevronOutlineGraphics: { [key: string]: IconGraphic[] } = {
  [Icon.ChevronRight]: [
    {
      d: 'M7.34331 20.6475C7.7995 21.1175 8.53498 21.1175 8.99116 20.6475L16.7277 12.6763C17.0908 12.3022 17.0908 11.6978 16.7277 11.3237L8.99116 3.35252C8.53498 2.88249 7.7995 2.88249 7.34331 3.35252C6.88713 3.82254 6.88713 4.58034 7.34331 5.05036L14.0837 12.0048L7.334 18.9592C6.88713 19.4197 6.88713 20.187 7.34331 20.6475Z'
    }
  ],
  [Icon.ChevronUp]: [
    {
      d: 'M20.6475 16.6567C21.1175 16.2005 21.1175 15.465 20.6475 15.0088L12.6763 7.27231C12.3022 6.90923 11.6978 6.90923 11.3237 7.27231L3.35252 15.0088C2.88249 15.465 2.88249 16.2005 3.35252 16.6567C3.82254 17.1129 4.58034 17.1129 5.05036 16.6567L12.0048 9.91632L18.9592 16.666C19.4197 17.1129 20.187 17.1129 20.6475 16.6567Z'
    }
  ],
  [Icon.ChevronDown]: [
    {
      d: 'M3.35252 7.34331C2.88249 7.7995 2.88249 8.53498 3.35252 8.99116L11.3237 16.7277C11.6978 17.0908 12.3022 17.0908 12.6763 16.7277L20.6475 8.99116C21.1175 8.53498 21.1175 7.7995 20.6475 7.34331C20.1775 6.88713 19.4197 6.88713 18.9496 7.34331L11.9952 14.0837L5.04077 7.334C4.58034 6.88713 3.81295 6.88713 3.35252 7.34331Z'
    }
  ],
  [Icon.ChevronLeft]: [
    {
      d: 'M16.6567 3.35252C16.2005 2.88249 15.465 2.88249 15.0088 3.35252L7.27231 11.3237C6.90923 11.6978 6.90923 12.3022 7.27231 12.6763L15.0088 20.6475C15.465 21.1175 16.2005 21.1175 16.6567 20.6475C17.1129 20.1775 17.1129 19.4197 16.6567 18.9496L9.91632 11.9952L16.666 5.04077C17.1129 4.58034 17.1129 3.81295 16.6567 3.35252Z'
    }
  ]
};
